import type { Table2DComponentSpec } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { isBound, widgetDatePatch } from "./_shared";

export const table2dControlPanel: ControlPanelHandler<Table2DComponentSpec> = (spec, patch) => {
  spec.table_2d_builder_misc = {
    ...spec.table_2d_builder_misc,
    ...(patch.applyDate && !isBound(spec.table_2d_builder_misc, "date", patch) && widgetDatePatch(patch.date)),
    ...(patch.applySubjects && !isBound(spec.table_2d_builder_misc, "subject", patch) && patch.subjects),
  };
};
